module.exports = __webpack_public_path__ + "static/media/logo350.13ee76ca.png";